export enum ToggleButtonVariant {
  Primary = 'Primary',
  Secondary = 'Secondary',
  Success = 'Success',
  Error = 'Error',
  Warning = 'Warning',
  Information = 'Information',
}

export type ToggleButtonSize =
  | 'XSmall'
  | 'Small'
  | 'Medium'
  | 'Large'
  | 'XLarge';
export type ToggleButtonState =
  | 'Enabled'
  | 'Hovered'
  | 'Focused'
  | 'Pressed'
  | 'Disabled';

import type React from 'react';

export interface ToggleButtonProps
  extends Omit<
    React.ButtonHTMLAttributes<HTMLButtonElement>,
    'type' | 'onChange'
  > {
  /**
   * Whether the toggle button is checked/on
   */
  checked?: boolean;
  /**
   * Callback fired when the toggle state changes
   */
  onChange?: (checked: boolean) => void;
  /**
   * The text label displayed on the toggle button (outside the toggle)
   */
  label?: string;
  /**
   * Text to display inside the toggle on the left when checked/on
   */
  onText?: string;
  /**
   * Text to display inside the toggle on the right when unchecked/off
   */
  offText?: string;
  /**
   * Icon component to display when unchecked (React element)
   */
  icon?: React.ReactNode;
  /**
   * Icon component to display when checked (React element)
   */
  checkedIcon?: React.ReactNode;
  /**
   * Toggle button variant: Primary, Secondary, Success, Error, Warning, or Information
   */
  variant?: ToggleButtonVariant;
  /**
   * Toggle button size variant
   */
  size?: ToggleButtonSize;
  /**
   * Toggle button state variant
   */
  state?: ToggleButtonState;
  /**
   * Additional CSS classes
   */
  className?: string;
  /**
   * Additional CSS classes for the label text
   */
  labelClassName?: string;
}
